<template>
    <div id='over'>
        <!-- <img src="/static/img/over.png" alt="">
        <p v-if="$store.state.notice.status==0">
            尊敬的用户，你好！<br>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{$store.state.webInfo.net_off_content}}
            <span style="display: block;text-align: right;">{{$store.state.webInfo.update_time}}</span>
        </p>
        <p v-if="$store.state.notice.status==1">
            {{$store.state.notice.information}}
        </p> -->
        <div><img style="width:438px;height:611px;" src="/static/img/ymsj.png" /> </div>
<p style="height: 40px;
font-size: 24px;
font-family: MicrosoftYaHei;
color: #262626;
line-height: 40px;margin-bottom:18px;position:relative;top:-40px;">页面升级维护中</p>
<p style="font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: rgba(38, 38, 38, 0.5);
line-height: 24px; width:500px;margin:0 auto;position:relative;top:-40px;">
  {{$store.state.webInfo.net_off_content}}{{$store.state.webInfo.update_time}} {{$store.state.notice.information}}
</p>
    </div>
</template>
<script>
export default {
    data() {
        return {

        }
    },
    mounted() {
        if(this.$store.state.notice.status==0){
            if(this.$store.state.webInfo.switch_status==1){
                this.$router.push({ name: "Home"});
            }
        }
    }
}
</script>

<style lang="less" scoped>
#over{
    position: relative;
    min-width: 1200px;
    width: 100%;
    height: 100vh;
    // img{
    //     width: 1920px;
    //     height: 100vh;
    //     position: absolute;
    //     top: 50%;
    //     left: 50%;
    //     transform: translate(-50%,-50%)
    // }
    p{
        // text-align: left;
        // width: 404px;
        // position: absolute;
        // top: 65%;
        // left: 50%;
        // margin-left: -202px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/activity/over.vue